import { gql } from 'graphql-request'

export const GlobalRoomsPageQuery = gql`
  query GlobalRoomsPage(
    $locale: LocaleInputType!
    $isPreview: Boolean! = false
  ) {
    RoomsPage(locale: $locale, draft: $isPreview) {
      title
      description
    }
  }
`
